import { render, staticRenderFns } from "./PassagesCourse.vue?vue&type=template&id=12eaedc3&scoped=true&"
import script from "./PassagesCourse.vue?vue&type=script&lang=js&"
export * from "./PassagesCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eaedc3",
  null
  
)

export default component.exports